import Circle from './../components/Circle';

const drawRings = (x, y, ir, mr, rings, colors) => {
    const elements = [];
    for (let i = rings; i > 0; i--) {
        const r = ir + (mr / rings) * i;
        elements.push(
            Circle.create()
                .size(x, y, r)
                .strokeColor('rgb(240, 240, 240)')
                .strokeThickness('2px')
                .fillColor(i === 3 ? colors.mean : colors.white)
                .element()
        );
    }

    return elements;
};

export default drawRings;
